import { Component, OnInit, AfterViewInit, ElementRef, ViewChildren } from '@angular/core';
import { AuthService } from '../auth.service';
import { AppCommonService } from '../appcommon.service';
import { FormGroup, FormBuilder, Validators, FormControlName } from '@angular/forms';
import { GenericValidator } from '../shared/generic-validator';
import { Observable } from 'rxjs/Observable';
import { ISurvey } from './Survey';
import { LoaderService } from '../LoaderService';
import { HomeService } from './home.service';
declare var $: any;
@Component({
  templateUrl: "./survey.component.html"
})
export class SurveyComponent implements OnInit, AfterViewInit {
  @ViewChildren(FormControlName, { read: ElementRef }) formInputElements: ElementRef[];
  public pageTitle: string = 'Customer Survey';
  surveyForm: FormGroup;
  survey: ISurvey;
  // Use with the generic validation message class
  displayMessage: { [key: string]: string } = {};
  private validationMessages: { [key: string]: { [key: string]: string } };
  private genericValidator: GenericValidator;

  constructor(private fb: FormBuilder,
    private authService: AuthService,
    private appCommonService: AppCommonService,
    public homeService: HomeService,
    public loaderService: LoaderService
  ) {
    this.appCommonService.pageContentAdditionalClass = "dashboard-page";
    this.appCommonService.pageName = this.pageTitle;

    // Defines all of the validation messages for the form.
    // These could instead be retrieved from a file or database.
    this.validationMessages = {
      q1: {
        required: 'q1 is required.'
      },
      q2: {
        required: 'q2 is required.'
      },
      q3: {
        required: 'q3 is required.'
      },
      q4: {
        required: 'q4 is required.'
      },
      q5: {
        required: 'q5 is required.'
      },
      q6: {
        required: 'q6 is required.'
      },
      q7: {
        required: 'q7 is required.'
      },
      q8: {
        required: 'q8 is required.'
      },
      q9: {
        required: 'q9 is required.'
      },
      q10: {
        required: 'q10 is required.'
      },
      q11: {
        required: 'q11 is required.'
      },
      comments: {
        required: 'comments is required.'
      }
    };

    // Define an instance of the validator for use with this form, 
    // passing in this form's set of validation messages.
    this.genericValidator = new GenericValidator(this.validationMessages);
  }
  ngOnInit() {
    this.surveyForm = this.fb.group({      
      q1: [0, Validators.required],
      q2: [0, Validators.required],
      q3: [0, Validators.required],
      q4: [0, Validators.required],
      q5: [0, Validators.required],
      q6: [0, Validators.required],
      q7: [0, Validators.required],
      q8: [0, Validators.required],
      q9: [0, Validators.required],
      q10: [0, Validators.required],
      q11: [0, Validators.required],
      comments: ['']
    });
  }

  ngAfterViewInit() {
    this.appCommonService.loadRequiredJS();
    // Watch for the blur event from any input element on the form.
    let controlBlurs: Observable<any>[] = this.formInputElements
      .map((formControl: ElementRef) => Observable.fromEvent(formControl.nativeElement, 'blur'));

    // Merge the blur event observable with the valueChanges observable
    Observable.merge(this.surveyForm.valueChanges, ...controlBlurs).debounceTime(500).subscribe(value => {
      this.displayMessage = this.genericValidator.processMessages(this.surveyForm);
    });
  }

  sendSurvey(): void {
    if (this.surveyForm.valid) {
      // Copy the form values over the product object values
      let p = Object.assign({}, this.survey, this.surveyForm.value);
      this.loaderService.display(true);
      this.homeService.sendSurvey(p)
        .subscribe(
        () => {
          $('#usersModal').modal('hide');
          this.loaderService.display(false);          
          this.homeService.showSuccess("Survey Submitted","Thank You.");
        },
        (error: any) => {          
          this.loaderService.display(false);
          this.homeService.showError("Survey sending problem", <any>error);
        }
        );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/home/survey.component.ts